import React from "react"
import useAppContext from "~/hooks/useAppContext"
import panelItems from "./panelItems"
import useIsSidebarOpen from "~/hooks/useIsSidebarOpen"
import { Block } from "baseui/block"

interface State {
  panel: string
}
const PanelsList = () => {
  const [state, setState] = React.useState<State>({ panel: "Categories" })
  const isSidebarOpen = useIsSidebarOpen()
  const { activePanel, activeSubMenu } = useAppContext()

  React.useEffect(() => {
    setState({ panel: activePanel })
  }, [activePanel])

  React.useEffect(() => {
    if (activeSubMenu) {
      setState({ panel: activeSubMenu })
    } else {
      setState({ panel: activePanel })
    }
  }, [activeSubMenu])

  let panel = state.panel
  panel = panel.split(" ").join("")
  // @ts-ignore
  const Component = panelItems[panel]

  return (
    <Block
      $style={{
        width: isSidebarOpen ? "306px" : 0,
      }}
      id="EditorPanelItem"
      className="left-panel-item-container"
    >
      {Component && <Component />}
    </Block>
  )
}

export default PanelsList
